import {
  GET_GUESTROOM_TYPES_FAILURE,
  GET_GUESTROOM_TYPES_REQUEST,
  GET_GUESTROOM_TYPES_SUCCESS,
} from 'actions/get-guest-room-types-action';

const initialState = {
  isLoading: false,
  error: '',
  guestRoomTypes: null,
};

const guestRoomsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GUESTROOM_TYPES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    case GET_GUESTROOM_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        guestRoomTypes: action.payload || [],
      };
    case GET_GUESTROOM_TYPES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
      };
    default:
      return state;
  }
};

export default guestRoomsReducer;
